<script>

import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import GenericDateTimeMaskV2 from '../../generic/GenericDateTimeMaskV2.vue'
import InputText from 'primevue/inputtext';
import ResponsiveButton from '../../generic/ResponsiveButton.vue';
import Service from '../../../services/operative-plan';

import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import GenericCustomMasterDataAutocompleteV2 from '../../generic/GenericCustomMasterDataAutocompleteV2.vue';

export default{
    props: ['item', 'refreshGrid'],
    components: {
        Dialog, GenericDateTimeMaskV2,
        DataTable, Column, InputText, ResponsiveButton,
        GenericCustomMasterDataAutocompleteV2
    },
    mounted(){
    },
    data(){
        return{
            visible: false,
            data: [],
            selectedData: []
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        }
    },
    methods: {
        show(){
            this.visible = true;
        },
        loadData(){
            this.data = [];
            this.selectedData = [];
            Service.getRecurringOperationTemplate({}, response => {
                if(response.success){
                    this.data = response.data;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onCellEditComplete(event) {
            // let { data, newValue, field, newData } = event;
            // data[field] = newValue;
            // if(field == 'equipmentOperationTank'){
            //     data['idEquipmentOperationTank'] = newData.idEquipmentOperationTank;
            // }
        },
        onTankSelected(){
        },
        insert(){
            if(this.selectedData.length > 0){
                let input = [];
                for(let i=0; i<this.selectedData.length; i++){
                    let d = this.selectedData[i];
                    input.push({
                        scheduledOperationDate: d.scheduledOperationDate,
                        idRegistryPlant: d.idRegistryPlant,
                        idRegistryOperationType: d.idRegistryOperationType,
                        //idRegistryOperationTypeClass: 0,
                        idEquipmentOperationTank: d.idEquipmentOperationTank,
                        idRegistryProduct: d.idRegistryProduct,
                        equipmentOperationQty: d.equipmentOperationQty,
                        idRegistryCompanyOwner: d.idRegistryCompanyOwner,
                        notes: d.notes,
                        // atk: 0,
                        // atb: 0,
                        isRecurringOperation: true
                    })
                }

                Service.addMass(input, this.item.planDate, response => {
                    if(response.success){
                        this.refreshGrid(true);
                        this.visible = false;
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }else{
                this.$toast.add({detail: this.$t('dailyPlanValidation.massSelectionRequired'), life:3000, severity:'warn'});
            }
        }
    }
}

</script>

<template>
    <main>
        <Dialog :header="$t('dailyPlanValidation.scheduledOperations')" v-model:visible="visible" :style="{width: '85vw'}" :modal="true">
            <DataTable :reorderableColumns="true" :value="data" showGridlines stripedRows class="p-datatable-sm" responsiveLayout="scroll"
                editMode="cell" @cell-edit-complete="onCellEditComplete" v-model:selection="selectedData">
                <Column selectionMode="multiple" headerStyle="width: 3em" :reorderableColumn="false"></Column>

                <Column field="scheduledOperationDate" :header="$t('dailyPlanValidation.operationDate')" :sortable="true">
                    <template #body="element">
                        <GenericDateTimeMaskV2 
                            v-model="element.data.scheduledOperationDate" 
                            mask="99/99/9999 99:99"
                            :unmask="true"
                            class="w-full p-inputtext-sm mt-1" /> 


                         <!-- {{element.data.scheduledOperationDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.scheduledOperationDate)) : null}} -->
                    </template>
                    <!-- <template #editor="{data, field}"> 
                        <GenericDateTimeMaskV2 
                            v-model="data[field]" 
                            mask="99/99/9999 99:99:99"
                            :unmask="true"
                            class="w-full p-inputtext-sm mt-1" /> 
                    </template> -->
                </Column>
                <Column field="registryPlant" :header="$t('registryPlant.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryPlant}}
                    </template>
                </Column>
                <Column field="equipmentOperationTank" :header="$t('tankOperations.tank')" :sortable="true">
                    <template #body="element">
                         <!-- {{element.data.equipmentOperationTank}} -->
                         <generic-custom-master-data-autocomplete-v-2
                            :changeFn="onTankSelected"
                        :name="'equipmentOperationTank'"
                            v-model="element.data.idEquipmentOperationTank" 
                            updateLabel="equipmentOperationTank"
                            api="masterdata/equipment-combo?type=SERB" />
                    </template>
                    <!-- <template #editor="{data, field}">
                       <generic-custom-master-data-autocomplete-v-2
                            :changeFn="onTankSelected"
                            :name="field"
                            v-model="data.idEquipmentOperationTank" 
                            updateLabel="equipmentOperationTank"
                            api="masterdata/equipment-combo?type=SERB" />
                    </template> -->
                </Column>
                <Column field="registryProduct" :header="$t('product.fk')" :sortable="true">
                    <template #body="element">
                        <!-- {{element.data.registryProduct}} -->
                        <generic-custom-master-data-autocomplete-v-2
                            :name="'registryProductS'"
                            v-model="element.data.idRegistryProduct" 
                            updateLabel="equipmentOperationTank"
                            api="masterdata/product-combo" />
                    </template>
                </Column>
                <Column field="registryOperationType" :header="$t('operationType.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryOperationType}}
                    </template>
                </Column>
                <Column field="registryCompanyOwner" :header="$t('company.fk')" :sortable="true">
                    <template #body="element">
                         <!-- {{element.data.registryCompanyOwner}} -->
                    <generic-custom-master-data-autocomplete-v-2
                            :name="'registryCompanyOwnerS'"
                            v-model="element.data.idRegistryCompanyOwner" 
                            updateLabel="registryCompanyOwner"
                            api="masterdata/company-combo" />
                    </template>
                </Column>
                <Column field="equipmentOperationQty" :header="$t('dailyPlanValidation.qty')" :sortable="true">
                    <template #body="element">
                        <InputNumber 
                            class="w-full" 
                            type="number" 
                            v-model="element.data.equipmentOperationQty" />
                        <!-- {{element.data.equipmentOperationQty}} -->
                    </template>
                    <!-- <template #editor="{data, field}">
                        <InputText 
                            class="w-full" 
                            type="number" 
                            v-model="data[field]" />
                    </template> -->
                </Column>
                <Column field="notes" :header="$t('operativePlan.notes')" :sortable="true">
                    <template #body="element">
                        <InputText 
                            class="w-full" 
                            type="text" 
                            v-model="element.data.notes" />
                        <!-- {{element.data.notes}} -->
                    </template>
                    <!-- <template #editor="{data, field}">
                        <InputText 
                            class="w-full" 
                            type="text" 
                            v-model="data[field]" />
                    </template> -->
                </Column>
            </DataTable>

            <template #footer>
                <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-sm m-1" @click="visible = false"/>
                <ResponsiveButton :label="$t('btn.insert')" icon="pi pi-plus" class="p-button-sm m-1" @click="insert"/>
            </template>

        </Dialog>
    </main>
</template>